import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Directions = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="directions icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.17158 1.33161L1.32843 9.17475C-0.233662 10.7368 -0.233666 13.2695 1.32843 14.8316L9.17157 22.6747C10.7337 24.2368 13.2663 24.2368 14.8284 22.6748L22.6716 14.8316C24.2337 13.2695 24.2337 10.7368 22.6716 9.17475L14.8284 1.33161C13.2663 -0.230489 10.7337 -0.230492 9.17158 1.33161ZM13.5 13.089V12.0032H10.5C10.2239 12.0032 10 12.2271 10 12.5032V15.5032C10 16.3316 9.32843 17.0032 8.5 17.0032C7.67158 17.0032 7 16.3316 7 15.5032V12.5032C7 10.5702 8.56701 9.0032 10.5 9.0032H13.5V7.91741C13.5 7.02651 14.5771 6.58034 15.2071 7.21031L17.7929 9.79609C18.1834 10.1866 18.1834 10.8198 17.7929 11.2103L15.2071 13.7961C14.5771 14.4261 13.5 13.9799 13.5 13.089Z"
    />
  </svg>
)
